import $ from "jquery";

import { ModalManager } from "../../../../javascript/utils/modal-manager";

// Javascript for user menu

namespace('Slzr.Theme.UserMenu', function(exports) {

  const modalManager = ModalManager.getInstance();

  // Element that caused modal to open
  let openerElement = null;

  // Even though this is openModal, it doesn't affect styles, just focus and state tracking
  function openModal(element, opener) {
    modalManager.openModal(element, () => {
      exports.hideMobileMenu(element);
    });

    if(opener) {
      opener.setAttribute('aria-expanded', true);
      openerElement = opener;
    }
  }

  function closeModal(element) {
    // Restore focus state
    modalManager.closeModal();

    if(openerElement) {
      openerElement.setAttribute('aria-expanded', false);
      openerElement = false;
    }
  }


  exports.showMenu = function() {
    document.getElementById('desktop-profile-menu').classList.toggle('em-open-menu');
    document.getElementById('angle-down-icon').classList.toggle('em-open-menu');

    const menuButton = document.getElementById('user-menu-button');

    if(menuButton.getAttribute('aria-expanded') === "true") {
      menuButton.setAttribute('aria-expanded', "false");
    } else {
      menuButton.setAttribute('aria-expanded', "true");
    }
  };

  exports.showMobileMenu = function(element) {
    const menuElement = document.getElementById('main-menu');
    menuElement.classList.add('em-open-menu');
    setTimeout(function() {
      menuElement.classList.add('em-checked');
      openModal(menuElement, element);
    }, 0); // defer to make animate

    document.getElementById('backdrop').classList.add('em-checked');
    $('html, body').addClass('em-scroll-body');
  };

  exports.hideMobileMenu = function(element) {
    $('html, body').removeClass('em-scroll-body');
    if (document.getElementById('main-menu') !== null) {
      document.getElementById('main-menu').classList.remove('em-checked', 'em-open-menu');
    }
    if (document.getElementById('backdrop') !== null) {
      document.getElementById('backdrop').classList.remove('em-checked');
    }
    if (document.getElementById('search-bar-component') !== null) {
      document.getElementById('search-bar-component').classList.remove('em-show');
    }

    closeModal(element);
  };

  exports.showMobileSearchBar = function(element) {
    $('html, body').toggleClass('em-scroll-body');
    const searchModal = document.getElementById('search-bar-component');
    searchModal.classList.add('em-show');
    setTimeout(function() {
      openModal(searchModal, element);
    }, 0);
    document.getElementById('backdrop').classList.add('em-checked');

    if(element) {
      element.setAttribute('aria-expanded', true);
    }
  };

  $(window).on('resize', function(){
    const win = $(this);
    if (win.width() >= 768) {
      Slzr.Theme.UserMenu.hideMobileMenu();
    }
  });
});
